import { TRegisterForm, TRegistrationRequestBody } from "../types";
import { FIELD_NAMES } from "./constants";

const mapRegisterFormToRequest = (form: TRegisterForm, token: string): TRegistrationRequestBody => ({
  recaptcha: token,
  email: form[FIELD_NAMES.EMAIL],
  fullName: form[FIELD_NAMES.FULL_NAME],
  password: form[FIELD_NAMES.PASSWORD],
  repeatedPassword: form[FIELD_NAMES.PASSWORD_REPEAT],
  phone: form[FIELD_NAMES.MOBILE_NUMBER],
  marketing: form[FIELD_NAMES.MARKETING],
});

export default mapRegisterFormToRequest;
